import React, { useContext, createContext, useMemo } from "react";

import { DateTime } from "luxon";

import { MeetOpsQuery } from "@app/analytics/meetops/types";
import {
  getQueryDateRangeFromDateTimes,
  getQueryKeyFromDateRanges,
} from "@app/analytics/utils";

interface WorkspaceOverviewContext {
  queryDateRanges: MeetOpsQuery["dateRanges"];
}

const defaultContext: WorkspaceOverviewContext = {
  queryDateRanges: [
    {
      startDate: DateTime.now(),
      endDate: DateTime.now(),
      tzName: "unknown",
    },
  ],
};

const workspaceOverviewContext = createContext(defaultContext);

export const WorkspaceOverviewProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const value = useProvideWorkspaceOverview();
  return (
    <workspaceOverviewContext.Provider value={value}>
      {children}
    </workspaceOverviewContext.Provider>
  );
};

export const useWorkspaceOverview = () => useContext(workspaceOverviewContext);

const useProvideWorkspaceOverview = (): WorkspaceOverviewContext => {
  const queryDateRanges = useMemo(() => {
    const today = DateTime.now();
    return getQueryDateRangeFromDateTimes({
      startDate: today.minus({ days: 30 }).startOf("day"),
      endDate: today,
    });
  }, []);

  return useMemo(
    () => ({ queryDateRanges }),
    [getQueryKeyFromDateRanges(queryDateRanges)]
  );
};
